import { DocumentNode } from 'graphql';
import {
	ClassificationsFilterQuery,
	LocationAssetFilterQuery,
	LocationFilterQuery,
	fileDataTypeFilterQuery,
} from '@app/pages/cmms/graphql/multiselect-filter.queries';

export interface IFilterOptionsQueryMap {
	[key: string]: IFilterOptionsQueryMapItem;
}

export interface IFilterOptionsQueryMapItem {
	query: DocumentNode;
	queryVariables?: { [key: string]: any };
	dataKey: string;
	idKey: string;
	nameKey: string;
}

export const filterOptionsQueryMap: IFilterOptionsQueryMap = {
	classifications: {
		query: ClassificationsFilterQuery,
		queryVariables: { type: 'BCT', first: 20 },
		dataKey: 'classifications',
		idKey: 'pk',
		nameKey: 'name',
	},
	classificationsAsset: {
		query: ClassificationsFilterQuery,
		queryVariables: { type: 'BCT', first: 20 },
		dataKey: 'classifications',
		idKey: 'pk',
		nameKey: 'name',
	},
	locationsAsset: {
		query: LocationAssetFilterQuery,
		queryVariables: { first: 20 },
		dataKey: 'locationMappings',
		idKey: 'locationId',
		nameKey: 'name',
	},
	locations: {
		query: LocationFilterQuery,
		queryVariables: { first: 20 },
		dataKey: 'locationMappings',
		idKey: 'locationId',
		nameKey: 'name',
	},
	documentType: {
		query: fileDataTypeFilterQuery,
		queryVariables: { first: 20 },
		dataKey: 'type',
		idKey: 'type',
		nameKey: 'name',
	},
};
